'use client';

import { useState, useMemo } from 'react';
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/ui/command/command';
import { blockRegistry } from '../registry';
import type { PageBlockType } from '../registry/types';

interface Props {
  onSelect: (type: PageBlockType) => void;
  onClose?: () => void;
  autoFocus?: boolean;
}

export function BlockPicker({ onSelect, autoFocus = true }: Props) {
  const [filter, setFilter] = useState('');

  const grouped = useMemo(() => {
    const cats: Record<string, (typeof blockRegistry)[PageBlockType][]> = {};
    for (const cfg of Object.values(blockRegistry)) {
      if (filter && !cfg.label.toLowerCase().includes(filter.toLowerCase())) continue;
      (cats[cfg.category] ??= []).push(cfg);
    }
    return cats;
  }, [filter]);

  return (
    <Command className="w-72">
      <CommandInput
        placeholder="Insert block…"
        autoFocus={autoFocus}
        value={filter}
        onValueChange={setFilter}
      />
      <CommandList>
        <CommandEmpty>No blocks match.</CommandEmpty>
        {Object.entries(grouped).map(([category, configs]) => (
          <CommandGroup key={category} heading={category}>
            {configs.map((cfg) => (
              <CommandItem key={cfg.type} value={cfg.label} onSelect={() => onSelect(cfg.type)}>
                <cfg.icon className="mr-2 h-4 w-4" />
                <span className="flex-1">{cfg.label}</span>
                <span className="text-xs text-muted-foreground">{cfg.description}</span>
              </CommandItem>
            ))}
          </CommandGroup>
        ))}
      </CommandList>
    </Command>
  );
}
